import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

const AgeGroup = ({ title, value }) => {
  const twentyFiveMax = value.filter((emp) => emp.age >= 18 && emp.age <= 25);
  const thertyFiveMax = value.filter((emp) => emp.age >= 26 && emp.age <= 35);
  const fourtyFiveMax = value.filter((emp) => emp.age >= 36 && emp.age <= 45);
  const fourtySixAbove = value.filter((emp) => emp.age >= 46);
  const data = [
    {
      name: "18 - 25",
      pv: twentyFiveMax.length || 0,
    },
    {
      name: "26 - 35",
      pv: thertyFiveMax.length || 0,
    },
    {
      name: "36 - 45",
      pv: fourtyFiveMax.length || 0,
    },
    {
      name: "46 & above",
      pv: fourtySixAbove.length || 0,
    },
  ];

  //   const getIntroOfPage = (label) => {
  //     if (label === "18 - 25") {
  //       return "Page A is about men's clothing";
  //     }
  //     if (label === "26 - 35") {
  //       return "Page B is about women's dress";
  //     }
  //     if (label === "36 - 45") {
  //       return "Page C is about women's bag";
  //     }
  //     if (label === "46 $ above") {
  //       return "Page D is about household goods";
  //     }
  //     return "";
  //   };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label} : ${payload[0].value}`}</p>
          {/* <p className="intro">{getIntroOfPage(label)}</p> */}
          {/* <p className="desc">Anything you want can be displayed here.</p> */}
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ width: "100%", height: 300 }}>
      <h4>{title}</h4>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="pv" barSize={20} fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AgeGroup;
